import styled from 'styled-components';

export const Label = styled.div`
  color: var(--grey700);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;
